import React, { Component } from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../src/lib/component-base';
import AccountError from './AccountError';

@componentBase('ChangePassword')
export default class ChangePassword extends Component {
  static propTypes = {
    errors: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.oldPassword = null;
    this.newPassword = null;
    this.passwordConfirm = null;
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  errorClass = field => (this.props.errors && this.props.errors[field] && 'error');

  render() {
    const { errors } = this.props;
    return (
      <div className='row account-large-modal'>
        <section className='change-password'>
          <div className='row'>
            <div className='col-xs-12 col-md-5'>
              <h3>Your Old Password</h3>
              <AccountError name='oldPassword' errorCode={errors && errors.oldPassword} />
              <input
                type='password'
                ref={ref => (this.oldPassword = ref)}
                placeholder='•••••••••'
                className={`account-input padded ${this.errorClass('oldPassword')}`}
              />
              <h3 className='spaced'>Your New Password</h3>
              <AccountError name='newPassword' errorCode={errors && errors.newPassword} />
              <input
                type='password'
                ref={ref => (this.newPassword = ref)}
                placeholder='•••••••••'
                className={`account-input padded ${this.errorClass('newPassword')}`}
              />
              <h3 className='spaced'>Confirm Your New Password</h3>
              <AccountError name='passwordConfirm' errorCode={errors && errors.passwordConfirm} />
              <input
                type='password'
                ref={ref => (this.passwordConfirm = ref)}
                placeholder='•••••••••'
                className={`account-input padded ${this.errorClass('passwordConfirm')}`}
              />
            </div>
            <div className='col-xs-12 col-md-1'>
              &nbsp;
            </div>
            <div className='col-xs-12 col-md-5 tips'>
              <h3>Password Tips</h3>
              <p>Follow these guidelines when choosing a password:</p>
              <ul>
                <li>
                  <p>
                    Longer passwords are more secure.
                    We recommend passwords be at least 8 characters.
                  </p>
                </li>
                <li>
                  <p>
                    Passwords are case-sensitive.
                    Consider using a mix of capital and lower-case numbers and symbols.
                  </p>
                </li>
                <li>
                  <p>
                    Avoid using passwords that are easy to guess such as the name of a pet,
                    your username or any common name or word.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Account/components/MyAccount/children/children/ChangePassword.js